/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';

function Input({
  value,
  onChange,
  onInput,
  onBlur,
  valid = true,
  disabled = false,
  message,
  label,
  name,
  type,
  required,
  minLength,
  maxLength,
  min,
  max,
  pattern,
  step,
  leftSlotContents = null,
  rightSlotContents = null,
  autoComplete,
  className = '',
}) {
  return (
    <div
      className={`
        uds-input
        ${valid ? '' : 'uds-input--error'} ${className}`}
    >
      <label
        className={`
          ${disabled && 'uds-input__control--disabled'}
          uds-input__control
        `}
      >
        {leftSlotContents && (
          <div className="uds-input__left_slot">{leftSlotContents}</div>
        )}
        <input
          value={value}
          onChange={(e) => onChange?.(e.target.value, value)}
          onInput={(e) => onInput?.(e.target.value, value)}
          onBlur={onBlur}
          name={name}
          className="uds-input__field"
          disabled={disabled}
          placeholder={name}
          required={required}
          type={type}
          minLength={minLength}
          maxLength={maxLength}
          min={min}
          max={max}
          pattern={pattern}
          step={step}
          autoComplete={autoComplete}
          aria-invalid={!valid}
        />
        <span className="uds-input__label">{label}</span>
        {rightSlotContents && (
          <div className="uds-input__right_slot">{rightSlotContents}</div>
        )}
        <div className="uds-input__border" />
      </label>
      {message && <div className="uds-input__message">{message}</div>}
    </div>
  );
}

Input.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onInput: PropTypes.func,
  onBlur: PropTypes.func,
  type: PropTypes.string,
  message: PropTypes.string,
  valid: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  min: PropTypes.string,
  max: PropTypes.string,
  pattern: PropTypes.string,
  step: PropTypes.string,
  autoComplete: PropTypes.string,
  leftSlotContents: PropTypes.node,
  rightSlotContents: PropTypes.node,
};

export default Input;
